export const COUNTRY_CODES = [
    { code: 'DE', dial: '+49', flag: '🇩🇪' },
    { code: 'US', dial: '+1',  flag: '🇺🇸' },
    { code: 'GB', dial: '+44', flag: '🇬🇧' },
    { code: 'FR', dial: '+33', flag: '🇫🇷' },
    { code: 'ES', dial: '+34', flag: '🇪🇸' },
    { code: 'IT', dial: '+39', flag: '🇮🇹' },
    { code: 'TR', dial: '+90', flag: '🇹🇷' },
    { code: 'IL', dial: '+972', flag: '🇮🇱' }
];

/** Strip every non-digit character (spaces, dashes, parens, leading +). */
const digitsOnly = (s) => (s || '').replace(/\D/g, '');

export const splitPhone = (phone) => {
    if (!phone) return { country: COUNTRY_CODES[0], localNumber: '' };
    const match = COUNTRY_CODES.find(c => phone.startsWith(c.dial));
    if (match) {
        return { country: match, localNumber: digitsOnly(phone.slice(match.dial.length)) };
    }
    return { country: COUNTRY_CODES[0], localNumber: digitsOnly(phone) };
};

/**
 * Build an E.164-formatted phone string: leading '+', country code, then the
 * subscriber number with every non-digit stripped. No spaces, dashes, or parens.
 *
 * @param {string} countryCode - ISO code from COUNTRY_CODES (e.g. 'IL').
 * @param {string} localNumber - Whatever the user typed; non-digits are dropped.
 * @returns {string} E.164 string, or '' when there's no subscriber number.
 */
export const toE164 = (countryCode, localNumber) => {
    const country = COUNTRY_CODES.find(c => c.code === countryCode) || COUNTRY_CODES[0];
    const digits = digitsOnly(localNumber);
    return digits ? `${country.dial}${digits}` : '';
};